module.exports = __webpack_public_path__ + "img/73.5f2323da.jpg";